import { createSlice } from "@reduxjs/toolkit";
import Axios from "axios";
import fileDownload from "js-file-download";

const baseURL = "https://atcilkm.listracker.accenture.com/listracker-apis";
//const baseURL = "http://localhost:1101";
export const ProjectMasterSlice = createSlice({
    name: "ProjectMaster",
    initialState: {
     error: false,
     projectMasterList: [],
     projectStatusList: [],
     username: null,
     userMaintenanceList: [],
     projectList:[],
     uploadStatus:null
    },
    reducers: {
        setProjectMasterList: (state, { payload }) => {
         state.error = false;
         state.projectMasterList = payload;
        },
        setError: (state) => {
         state.error = true;
        },
        editRow: (state, { payload }) => {
        state.projectMasterList.map((item) => {
        if (item.slNo == payload.slNo) {
        item.endDate = payload.endDate;
        item.status = payload.status;
        }
        });
        state.projectMasterList.map((val, i) => {
        val.slNo = i + 1;
        });
        },
        setProjectStatusList: (state, { payload }) => {
          state.error = false;
          state.projectStatusList = payload;
         },
         setUsername: (state, { payload }) => {
          state.username = payload.name;
         },
         setUserMaintenanceList: (state, { payload }) => {
          state.error = false;
          state.userMaintenanceList = payload;
         },
         setProjectList: (state, { payload }) => {
          state.error = false;
          state.projectList = payload;
         },
         deleteRow: (state, { payload }) => {
          let updatedObjects = state.projectMasterList.filter((item) => item.id !== payload);
          state.projectMasterList = updatedObjects;
         },
         uploadSuccess: (state) => {
          state.uploadStatus = 'success';
        },
        uploadFailure: (state) => {
          state.uploadStatus = 'failure';
        },
        deleteIndividualRow: (state, { payload }) => {
          let updatedObjects = state.projectStatusList.filter((item) => item.id !== payload);
          state.projectStatusList = updatedObjects;
         },
    }
});

// Action creators are generated for each case reducer function
export const {
    setProjectMasterList,
    setError,
    editRow,
    setProjectStatusList,
    setUsername,
    setUserMaintenanceList,
    setProjectList,
    deleteRow,
    deleteIndividualRow,
    uploadSuccess,
    uploadFailure
   } = ProjectMasterSlice.actions;
   
   export default ProjectMasterSlice.reducer;


   export function getProjectMasterList(requestType) {    
    return (dispatch) => {
     Axios.get(`${baseURL}/fetchProjectMasterList/${requestType}`)
      .then((res) => {
        // res.data.map((val, i) => {
        //     val.slNo = i + 1;
        //    });
       dispatch(setProjectMasterList(res.data));
       console.log("res from get project master list", res.data);
      })
      .catch((err) => {
       dispatch(setError(err));
       console.error("error is", err);
      });
    };
   }


   export function downloadCategory() {
    return (dispatch) => {
     Axios.get(`${baseURL}/downloadExcel`, {
      responseType: "blob",
     })
      .then((res) => {
       fileDownload(res.data, `Project Master List.xlsx`);
      })
      .catch((err) => {
       console.error("error is", err);
      });
    };
   }


   export function editProjectMasterRow(slNo, endDate, status) {
    return (dispatch) => {
     Axios.post(`${baseURL}/editProjectMasterList/${slNo}`, { endDate, status }, {})
      .then((res) => {
       console.log("edited endDate and status", res.data);
       dispatch(editRow({ slNo, endDate, status }));
      })
      .catch((err) => {
       console.error("error in endDate and status", err);
      });
    };
   }

   export function getProjectStatusList() {
    return (dispatch) => {
     Axios.get(`${baseURL}/getDailyTaskUpdateData`)
      .then((res) => {
        // res.data.map((val, i) => {
        //     val.id = i + 1;
        //    });
       dispatch(setProjectStatusList(res.data));
       console.log("res from get project status list", res.data);
      })
      .catch((err) => {
       dispatch(setError(err));
       console.error("error is", err);
      });
    };
   }

  export function updateLoginUserName(name) {
    return (dispatch) => {
     dispatch(setUsername({ name }));
    };
   }

   export function getIndividualProjectStatusList(username) {
    return (dispatch) => {
     Axios.get(`${baseURL}/getIndividualDailyTaskUpdateData/${username}`)
      .then((res) => {
        // res.data.map((val, i) => {
        //     val.id = i + 1;
        //    });
       dispatch(setProjectStatusList(res.data));
       console.log("res from get project status list", res.data);
      })
      .catch((err) => {
       dispatch(setError(err));
       console.error("error is", err);
      });
    };
   }


   export function getUserMaintenanceList() {
    return (dispatch) => {
     Axios.get(`${baseURL}/getUserMaintenanceData`)
      .then((res) => {
        // res.data.map((val, i) => {
        //     val.id = i + 1;
        //    });
       dispatch(setUserMaintenanceList(res.data));
       console.log("res from get user maintenance list", res.data);
      })
      .catch((err) => {
       dispatch(setError(err));
       console.error("error is", err);
      });
    };
   }

   export function getProjectList() {
    return (dispatch) => {
     Axios.get(`${baseURL}/fetchAllProjects`)
      .then((res) => {
        // res.data.map((val, i) => {
        //     val.id = i + 1;
        //    });
       dispatch(setProjectList(res.data));
       console.log("res from get project status list", res.data);
      })
      .catch((err) => {
       dispatch(setError(err));
       console.error("error is", err);
      });
    };
   }

   export function deleteProjectMasterRow(id) {
    return (dispatch) => {
     Axios.delete(`${baseURL}/deleteProjectMasterRow/${id}`)
      .then((res) => {
       dispatch(deleteRow(id));
       console.log("deleted id", res.data);
      })
      .catch((err) => {
       dispatch(setError(err));
      });
    };
   }


   export function uploadProjectMaster(file) {
    return (dispatch) => {
     Axios.post(`${baseURL}/upload`, file)
      .then((res) => {
       // then print response status
       console.log(res);
       dispatch(uploadSuccess());
      })
      .catch((err) => {
       // then print response status
       console.error("upload fail");
       dispatch(uploadFailure());
      });
    };
   }


   export function deleteProjectIndividualStatusRow(id) {
    return (dispatch) => {
     Axios.delete(`${baseURL}/deleteProjectIndividualStatusRow/${id}`)
      .then((res) => {
       dispatch(deleteIndividualRow(id));
       console.log("deleted id", res.data);
      })
      .catch((err) => {
       dispatch(setError(err));
      });
    };
   }